import axios from './axios';
import config from '../config';

const billingApiRoot = config.API_ROOT;

export const getAllInvoices = <T>() => axios.get<T>('/invoices', { baseURL: billingApiRoot });

export const getBuilderInvoices = <T>(builderId: string | number) => axios.get<T>(`/invoices/${builderId}`, {
  baseURL: billingApiRoot,
});

export const getInvoiceById = <T>(id: string) => axios.get<T>(`/invoices/${id}`,
  {
    baseURL: billingApiRoot,
  });

export const getFakePdf = () => axios.get('/invoices/fake-pdf', {
  baseURL: billingApiRoot,
});
